module.exports = __webpack_public_path__ + "img/Zetrix-Logo.6f0fba9c.png";